import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  deleteObj,
  getClientPage,
  exportExcel,
  attentionAnalysis,
  deleteByAnalyzeDatetimeRange,
} from '@/api/tracksintegrityanalysisanalysisresultserv'

export default {
  state: {
    state_TracksIntegrityAnalysisAnalysisResult_GetAllResult: null,
    state_TracksIntegrityAnalysisAnalysisResult_SearchByNameResult: null,
    state_TracksIntegrityAnalysisAnalysisResult_GetPageResult: null,
    state_TracksIntegrityAnalysisAnalysisResult_GetDetailResult: null,
    state_TracksIntegrityAnalysisAnalysisResult_DeleteObjResult: null,
    state_TracksIntegrityAnalysisAnalysisResult_GetClientPageResult: null,
    state_TracksIntegrityAnalysisAnalysisResult_ExportExcelResult: null,
    state_TracksIntegrityAnalysisAnalysisResult_AttentionAnalysisResult: null,
    state_TracksIntegrityAnalysisAnalysisResult_DeleteByAnalyzeDatetimeRangeResult: null,
  },
  mutations: {
    SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_GETALL_RESULT: (state, rst) => {
      state.state_TracksIntegrityAnalysisAnalysisResult_GetAllResult = rst;
    },
    SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_TracksIntegrityAnalysisAnalysisResult_SearchByNameResult = rst;
    },
    SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_TracksIntegrityAnalysisAnalysisResult_GetPageResult = rst;
    },
    SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_TracksIntegrityAnalysisAnalysisResult_GetDetailResult = rst;
    },
    SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_DELETEOBJ_RESULT: (state, rst) => {
      state.state_TracksIntegrityAnalysisAnalysisResult_DeleteObjResult = rst;
    },
    SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_TracksIntegrityAnalysisAnalysisResult_GetClientPageResult = rst;
    },
    SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_TracksIntegrityAnalysisAnalysisResult_ExportExcelResult = rst;
    },
    SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_ATTENTIONANALYSIS_RESULT: (state, rst) => {
      state.state_TracksIntegrityAnalysisAnalysisResult_AttentionAnalysisResult = rst;
    },
    SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_DELETEBYANALYZEDATETIMERANGE_RESULT: (state, rst) => {
      state.state_TracksIntegrityAnalysisAnalysisResult_DeleteByAnalyzeDatetimeRangeResult = rst;
    },
  },
  actions: {
    TracksIntegrityAnalysisAnalysisResultServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TracksIntegrityAnalysisAnalysisResultServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TracksIntegrityAnalysisAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TracksIntegrityAnalysisAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TracksIntegrityAnalysisAnalysisResultServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TracksIntegrityAnalysisAnalysisResultServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TracksIntegrityAnalysisAnalysisResultServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TracksIntegrityAnalysisAnalysisResultServ_AttentionAnalysis({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        attentionAnalysis(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_ATTENTIONANALYSIS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_ATTENTIONANALYSIS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TracksIntegrityAnalysisAnalysisResultServ_DeleteByAnalyzeDatetimeRange({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteByAnalyzeDatetimeRange(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_DELETEBYANALYZEDATETIMERANGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRACKSINTEGRITYANALYSISANALYSISRESULT_DELETEBYANALYZEDATETIMERANGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_TracksIntegrityAnalysisAnalysisResult_GetAllResult: state => {
      return state.state_TracksIntegrityAnalysisAnalysisResult_GetAllResult;
    },
    get_TracksIntegrityAnalysisAnalysisResult_SearchByNameResult: state => {
      return state.state_TracksIntegrityAnalysisAnalysisResult_SearchByNameResult;
    },
    get_TracksIntegrityAnalysisAnalysisResult_GetPageResult: state => {
      return state.state_TracksIntegrityAnalysisAnalysisResult_GetPageResult;
    },
    get_TracksIntegrityAnalysisAnalysisResult_GetDetailResult: state => {
      return state.state_TracksIntegrityAnalysisAnalysisResult_GetDetailResult;
    },
    get_TracksIntegrityAnalysisAnalysisResult_DeleteObjResult: state => {
      return state.state_TracksIntegrityAnalysisAnalysisResult_DeleteObjResult;
    },
    get_TracksIntegrityAnalysisAnalysisResult_GetClientPageResult: state => {
      return state.state_TracksIntegrityAnalysisAnalysisResult_GetClientPageResult;
    },
    get_TracksIntegrityAnalysisAnalysisResult_ExportExcelResult: state => {
      return state.state_TracksIntegrityAnalysisAnalysisResult_ExportExcelResult;
    },
    get_TracksIntegrityAnalysisAnalysisResult_AttentionAnalysisResult: state => {
      return state.state_TracksIntegrityAnalysisAnalysisResult_AttentionAnalysisResult;
    },
    get_TracksIntegrityAnalysisAnalysisResult_DeleteByAnalyzeDatetimeRangeResult: state => {
      return state.state_TracksIntegrityAnalysisAnalysisResult_DeleteByAnalyzeDatetimeRangeResult;
    },
  }
}